import { graphql, useStaticQuery } from 'gatsby'
import { ArtisanDictionary } from '.'

type MicrocmsData = {
  allArtisanDictionary: {
    nodes: ArtisanDictionary[]
  }
}
export const useDictionary = () => {
  const data = useStaticQuery<MicrocmsData>(graphql`
    {
      allArtisanDictionary {
        nodes {
          en
          imageUrl
          ja
          articleIds
        }
      }
    }
  `)

  return data.allArtisanDictionary.nodes
}
